import { getInit } from "./InitEquipmentV2";
import OptionalEquipment from "./components/toyota/optional/OptionalEquipment";

// Webpack entry point for Optional Equipment Toyota.
export const init = getInit(OptionalEquipment);
